/**
 * Session Content Component
 *
 * Displays session title, description, and materials.
 */

import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getLocalizedTitle, getLocalizedDescription } from '@immopersian/common';
import { MaterialRenderer } from '../MaterialRenderer';

interface SessionContentProps {
  session: any;
}

export function SessionContent({ session }: SessionContentProps) {
  const { t, i18n } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6">
      <div className="mb-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-brand-dark mb-2">
          {getLocalizedTitle(session, i18n.language)}
        </h2>
        {session.description && (
          <div className="prose prose-gray max-w-none text-brand-dark">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {getLocalizedDescription(session, i18n.language)}
            </ReactMarkdown>
          </div>
        )}
      </div>

      {session.materials && session.materials.length > 0 ? (
        <div className="space-y-12">
          {session.materials.map((item: any) => (
            <MaterialRenderer key={item.material.id} material={item.material} sessionId={session.id} />
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-lg border border-brand-beige p-8 text-center">
          <svg className="w-16 h-16 mx-auto text-brand-beige mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p className="text-brand-dark">{t('courses.noMaterials')}</p>
        </div>
      )}
    </div>
  );
}
